import { GoBack } from "@/components/shared"
import { Sheet, SheetContent } from "@/components/ui"
import { GuideInstructions } from "@/features/jobs/manage/components/draft/guide-instructions"
import ScreenLayout from "@/layouts/screen"
import { ESubmitStatus } from "@/modules/helpers/enum"
import { Potential } from "@/modules/types"

interface UploadDraftModalProps {
  open: boolean
  onClose: () => void
  potentials?: Potential[]
  drafts: any[]
  disabled?: boolean
  totalClip: number
  submitStatus: ESubmitStatus
  submissionId: string
  isCastCamp: boolean
  refetch: () => void
  loading: boolean
  workingAt: string
}

export const UploadDraftModal = ({
  loading,
  open,
  onClose,
  potentials,
  disabled,
  submitStatus,
  totalClip,
  submissionId,
  isCastCamp,
  refetch,
  drafts,
  workingAt
}: UploadDraftModalProps) => {
  return (
    <Sheet open={open} modal>
      <SheetContent className="w-full !bg-transparent border-none" side="right" hiddenClose>
        <ScreenLayout transition="none">
          <div className="flex flex-col h-full relative overflow-hidden">
            <div className="sticky top-0 z-10">
              <GoBack
                className="bg-white"
                title={isCastCamp ? "Quản lý bản nháp và đường dẫn" : "Quản lý đường dẫn"}
                onClick={onClose}
              />
            </div>
            <div className="flex-1 overflow-auto">
              <GuideInstructions
                draftList={drafts}
                loading={loading}
                workingAt={workingAt}
                potentials={potentials}
                submissionId={submissionId}
                disabled={disabled}
                totalClip={totalClip}
                submitStatus={submitStatus}
                isCastCamp={isCastCamp}
                refetch={refetch}
              />
            </div>
          </div>
        </ScreenLayout>
      </SheetContent>
    </Sheet>
  )
}
